import AngularLink from "../../../../../../global/components/AngularLink/AngularLink.vue";
import PuxIcon from "../../../../../../global/components/PuxIcon/PuxIcon.vue";
import RollenModalAdd from "../RollenModalAdd/RollenModalAdd.vue";

import PermissionMixin from "../../../../../../global/mixins/PermissionMixin";
import RolenListInNutzerMixin from "../RolenListInNutzer.mixin";

import getTableApi from "../../../../../../const/TableApis";
import { gettext } from "../../../../../../global/functions/utils";

import {
  isNil
} from "lodash-es";

import moment from "moment";

const TABLE_ID = "RolenFoerderorganisationenListInNutzer";

// @vue/component
export default {
  name: "RolenFoerderorganisationenList",
  components: {
    AngularLink,
    PuxIcon,
    RollenModalAdd,
  },
  mixins: [
    PermissionMixin,
    RolenListInNutzerMixin,
  ],
  data() {
    return {
      tableId: TABLE_ID,
      options: {
        id: TABLE_ID,
        url: "",
        cols: [
          {
            label: "_LBL_ROLLEN_LIST_STATUS_",
            id: "aktiv",
            slot: "aktiv",
          },
          {
            label: "_LBL_ROLLEN_LIST_ORGANISATION_",
            id: "org_name",
          },
          {
            label: "_LBL_ROLLEN_LIST_ROLLE_",
            id: "rolle_name",
            slot: "rolle_name",
          },
          {
            label: "_LBL_ROLLEN_LIST_GUELTIG_AB_",
            id: "fnr_gueltig_ab",
            slot: "fnr_gueltig_ab",
          },
          {
            label: "_LBL_ROLLEN_LIST_GUELTIG_BIS_",
            id: "fnr_gueltig_bis",
            slot: "fnr_gueltig_bis",
          },
        ],
        rowActions: [
          {
            label: "_LBL_ROLLEN_LIST_ACTION_ROW_DETAILS_",
            route: "root.rollenverwaltung.detail",
            routeParameters: [{ routeId: "id", rowPath: "rolle" }],
            isHidden: () => !this.canViewRoles
          },
          // {
          //   label: "Rollenzuordnung entfernen",
          //   callback: this.confirmRemoveNutzerRole_mixin,
          //   isHidden: ({ item }) => item.aktiv || moment().isAfter(item.fnr_gueltig_ab),
          // },
          {
            label: "_LBL_ROLLEN_LIST_ROLLENZUORDNUNG_DEAKTIVIEREN_",
            callback: this.confirmDeactivateNutzerRole_mixin,
            isHidden: ({ item }) => !item.aktiv || !this.canUpdate({ item }),
          },
          {
            label: "_LBL_ROLLEN_LIST_GUELTIGKEITSZEITRAUM_ANPASSEN_",
            callback: this.openModalGueltigkeitszeitraumAnpassen_mixin,
            isHidden: ({ item }) => this.isPast({ item }) || !this.canUpdate({ item }),
          },
        ],
        actions: [
          {
            label: "_LBL_ROLLEN_LIST_ROLLE_HINZUFUEGEN_",
            isHidden: () => !this.canCreate,
            callback: this.addRolle_mixin,
            type: "button",
            className: "btn btn-default",
            icon: "glyphicon-plus",
            htmlId: "nutzer_foerderorgrollen_create",
          },
        ],
        label: "_LBL_ROLLEN_LIST_FOERDERORGANISATIONEN_",
        sortable: false,
        pagination: true,
        details: false,
        urlUpdate: false,
        showHeader: false,
        showColsConfig: false,
      },
      prefix: "fnr",
      apiSufix: "foerderorgrollen",
      moeglicheRollenUrl: null,
    };
  },
  computed: {
    canCreate() {
      return this.checkPermissionsSync({
        perm: "nutzer.foerderorgrollen.create",
        permArray: this.nutzer.user_permissions
      });
    },

    modalAddOptionsList() {
      return [
        {
          id: "foerderorg",
          type: "select",
          label: "_LBL_ROLLEN_LIST_ORGANISATION_",
          required: true,
          url: `/foerderorgrollen/moegliche_organisationen/`,
          keyGroup: "group",
          search: true,
          searchList: ["o_name"],
          keyId: "pk",
          keyLabel: "o_name",
          view: "v",
          change: ({ item }) => this.updataeMoeglicheRollenUrl(item)
        },
        {
          id: "rolle",
          type: "select",
          required: true,
          disabled: isNil(this.moeglicheRollenUrl),
          url: this.moeglicheRollenUrl,
          keyId: "fro_id",
          keyLabelCallback: ({ item }) => `${ item.fro_kbez } - ${ item.fro_bez }`,
          search: true,
          searchList: ["fro_kbez", "fro_bez"],
          label: "_LBL_ROLLEN_LIST_ROLLE_",
          view: "v",
        },
        {
          id: "gueltigkeit",
          type: "daterange",
          label: gettext("_LBL_ROLLEN_LIST_GUELTIGKEITSZEITRAUM_"),
          view: "v-alt",
          placeholderMin: gettext("_LBL_ROLLEN_LIST_AB_HEUTE_"),
          placeholderMax: gettext("_LBL_ROLLEN_LIST_UNEINGESCHRAENKT_"),
        },
      ];
    },

    canViewRoles() {
      return this.checkPermissionsSync({ perm: "rollen.view" });
    },

  },
  created() {
    this.initUrl();
  },
  methods: {
    initUrl() {
      this.options.url = getTableApi({ id: TABLE_ID, params: { nutzerPk: this.nutzer.pk } });
    },

    canUpdate({ item }) {
      return this.checkPermissionsSync({
        perm: "nutzer.foerderorgrollen.update",
        permArray: item.user_permissions
      });
    },

    isPast({ item }) {
      return item.fnr_gueltig_bis && moment().isAfter(item.fnr_gueltig_bis);
    },

    updataeMoeglicheRollenUrl(org) {
      this.moeglicheRollenUrl = `/foerderorganisationen/${ org.pk }/rollenfreigaben/verwendbare_rollen/`;
    },

    onCloseModalAdd() {
      this.moeglicheRollenUrl = undefined;
    },
  },
};
